import crypto from 'crypto'
import { EncryptionAlgorithm } from '../types/core-types'

const ENCRYPTION_KEY: EncryptionAlgorithm = (process.env.ENCRYPTION_KEY as EncryptionAlgorithm) || 'aes-128-cbc'
const encrypt = (data: string, key: string, algorithm: EncryptionAlgorithm = ENCRYPTION_KEY) => {
  const hashedKey = toMD5Hash(key)
  try {
    const cipher = crypto.createCipheriv(algorithm, hashedKey, hashedKey)
    let encrypted = cipher.update(data, 'utf8', 'base64')
    encrypted += cipher.final('base64')
    return encrypted
  } catch (err) {
    return JSON.stringify(err) ?? ''
  }
}

const decrypt = (data: string, key: string, algorithm: EncryptionAlgorithm = ENCRYPTION_KEY) => {
  const hashedKey = toMD5Hash(key)
  const decipher = crypto.createDecipheriv(algorithm, hashedKey, hashedKey)
  let text = decipher.update(data, 'base64', 'utf8')
  text += decipher.final('utf8')
  return text
}
function toMD5Hash(content: string, algo = 'md5') {
  const hashFunc = crypto.createHash(algo) // you can also sha256, sha512 etc
  hashFunc.update(content)
  return hashFunc.digest() // will return hash, formatted to HEX
}

async function hash(data: string) {
  // Encode the input string as a Uint8Array
  const msgBuffer = new TextEncoder().encode(data)

  // Hash the message using SHA-256
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)

  // Convert ArrayBuffer to Array
  const hashArray = Array.from(new Uint8Array(hashBuffer))

  // Convert bytes to hex string
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
  return hashHex
}

export default { encrypt, decrypt, toMD5Hash, hash }
